module.exports = __webpack_public_path__ + "static/media/mp.64e9a64e.png";